import { render, staticRenderFns } from "./table.vue?vue&type=template&id=541aab94&scoped=true"
import script from "./table.ts?vue&type=script&lang=ts&external"
export * from "./table.ts?vue&type=script&lang=ts&external"
import style0 from "./table.vue?vue&type=style&index=0&id=541aab94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541aab94",
  null
  
)

export default component.exports